module.exports = __webpack_public_path__ + "static/hitec_info-a0f5808d6a2c142b6e7251c477735c70.png";